import CustomButton from "../../../components/CustomButton";
import Input, {InputIcon} from "../../../components/form/Input";
import CustomModal from "../../../components/CustomModal";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setManageUserModals, tryAddOrUpdateUsers} from "../../../redux/slices/manageUserSlice";
import useInput from "../../../hooks/useInput";
import {isEmailValid} from "../../../helpers/helperFunctions";
import useDidMount from "../../../hooks/useDidMount";
import {isValidPassword} from "../../../helpers/validationHelper";
import CustomCheckBox from "../../../components/form/CustomCheckBox";


export default function ManageUserFormModal({fromList = false}) {

  const [passwordVisible, setPasswordVisible] = useState(false)
  const updatePassword = useInput(false, true)
  const {modal, data} = useSelector((state => state.manageUser.modals.form));
  const dispatch = useDispatch();
  const firstName = useInput("")
  const lastName = useInput("")
  const email = useInput("")
  const password = useInput("")

  const {
    loading: editing,
  } = useSelector((state) => state.dynamicElements.editing);
  const isEditForm = !!data;
  const isFormValid = firstName.value.trim() && lastName.value.trim() && isEmailValid(email.value) && ((isEditForm && !updatePassword.value) || isValidPassword(password.value.trim()))


  const submitForm = ()=>{
    dispatch(tryAddOrUpdateUsers({
      "first_name": firstName.value.trim(),
      "last_name": lastName.value.trim(),
      ...(!isEditForm && {"email": email.value.trim()}),
      ...((!isEditForm || updatePassword.value) && {"password": password.value.trim()})

    }))
  }

  useDidMount(()=>{
    if(!modal){
      firstName.setValue("")
      lastName.setValue("")
      email.setValue("")
      password.setValue("")
      setPasswordVisible(false)
      updatePassword.setValue(false)
    }else if(isEditForm){
      firstName.setValue(data.first_name)
      lastName.setValue(data.last_name)
      email.setValue(data.email)
      password.setValue("")
    }
  }, [modal])


  return (
    <CustomModal title={isEditForm ? "Update Profile" : "Create New User"}
                 bodyClasses="max-w-screen-sm"
                 showModal={modal}
                 setShowModal={() => dispatch(setManageUserModals())}
                 loading={editing}
                 button={<CustomButton disabled={editing || !isFormValid}
                                       onClick={submitForm}>{isEditForm ? "Update" : "Create"}</CustomButton>}>
      <div className="flex flex-col p-2 space-y-4">

        <div className="flex space-x-5">

          <Input label="First Name" type="text" color="lightBlue" size="lg"
                 placeholder="Name"
                 disabled={editing}
            value={firstName.value}
            onChange={firstName.onChange}
                 hideError={true}
          />

          <Input label="Last Name" type="text" color="lightBlue" size="lg"
                 placeholder="Last Name" disabled={editing}
                 value={lastName.value}
                 onChange={lastName.onChange}
                 hideError={true}
          />
        </div>

        <Input label="Email" type="text" color="lightBlue" size="lg" placeholder="Email"
               hideError={!email.value || isEmailValid(email.value)}
               disabled={editing || isEditForm} value={email.value}
               errorMessage="invalid email"
               onChange={email.onChange}/>

        {(isEditForm && fromList) && <CustomCheckBox label="Update password" onChange={updatePassword.onChange} checked={updatePassword.value}/>}

        {(!isEditForm || updatePassword.value) && <Input disabled={editing} label="Password" type={passwordVisible ? 'text' : 'password'} color="lightBlue" size="lg" placeholder="Password"
               name="new-password"
               id="new-password"
               autoComplete="new-password"
               value={password.value}
               onChange={password.onChange}
               errorMessage="Password must have a special character, both small and capital letter, a number and be between 8-16 characters."
               hideError={!password.value ||   isValidPassword(password.value.trim())}
               postIcon={
                 <InputIcon
                   icon={passwordVisible ? 'visibility' : 'visibility_off'}
                   onClick={() => setPasswordVisible(!passwordVisible)}
                 />
               }
        />}


      </div>
    </CustomModal>
  );
}